/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Calories_RangeInputs */

const en_exp_calories_range = /** @type {(inputs: Exp_Calories_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expect ±15 % from power or running data and ±25 % from heart rate. Wrist devices are often off by 27 % or more.`)
};

const de_exp_calories_range = /** @type {(inputs: Exp_Calories_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechne mit ±15 % bei Leistungs- oder Laufdaten und ±25 % bei Herzfrequenz. Uhren am Handgelenk liegen oft 27 % oder mehr daneben.`)
};

/**
* | output |
* | --- |
* | "Expect ±15 % from power or running data and ±25 % from heart rate. Wrist devices are often off by 27 % or more." |
*
* @param {Exp_Calories_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_calories_range = /** @type {((inputs?: Exp_Calories_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Calories_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_calories_range(inputs)
	return de_exp_calories_range(inputs)
});